import { types, Instance } from 'mobx-state-tree';
import UserStore from './user/UserStore';
import WorkoutPlayerStore from './workoutPlayer/WorkoutPlayerStore';
import GuidedWorkoutPlayerStore from './guidedWorkoutPlayer/GuidedWorkoutPlayerStore';
import WorkoutSessionStore from './workoutSession/WorkoutSessionStore';
import SubscriptionStore from './subscription/SubscriptionStore';

const RootStore = types.model('RootStore', {
  userStore: types.optional(UserStore, {}),
  workoutPlayerStore: types.optional(WorkoutPlayerStore, {}),
  guidedWorkoutPlayerStore: types.optional(GuidedWorkoutPlayerStore, {}),
  workoutSessionStore: types.optional(WorkoutSessionStore, {}),
  subscriptionStore: types.optional(SubscriptionStore, {}),
});

export type IRootStore = Instance<typeof RootStore>;

export default RootStore;
